export default function Manifesto() {
  return (
    <section
      id="manifest"
      data-testid="manifesto-section"
      className="relative py-16 sm:py-24 lg:py-40 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-cm-beige" />
      <div
        aria-hidden
        className="absolute -z-10 left-1/2 top-0 -translate-x-1/2 w-[1100px] h-[1100px] rounded-full blur-3xl opacity-40"
        style={{ background: "radial-gradient(circle, #E8C7C0 0%, transparent 65%)" }}
      />
      <div className="grain absolute inset-0 -z-10" />

      <div className="max-w-[1240px] mx-auto px-5 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-10 sm:gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-8 reveal order-2 lg:order-1">
          <span className="ornament" data-testid="manifesto-eyebrow">
            <em>Manifest</em>
          </span>
          <h2
            data-testid="manifesto-headline"
            className="font-serif text-cm-ink mt-8 text-[1.75rem] sm:text-4xl lg:text-[2.8rem] leading-[1.18] sm:leading-[1.14] tracking-[-0.005em] max-w-xl"
          >
            Et blad slipper ikke træet i hast.{" "}
            <span className="marker">Det giver efter.</span>
          </h2>

          <div className="mt-10 space-y-5 text-cm-ink-soft leading-[1.85] max-w-xl">
            <p data-testid="manifesto-paragraph-1">
              Først næsten umærkeligt — en svag løsnen, en lille forskydning i
              det, der før var fast. Stilken tørrer ind, forbindelsen tyndes, og
              uden dramatik opstår en stille erkendelse: tiden er kommet.
            </p>
            <p data-testid="manifesto-paragraph-2">
              Sådan er det også i livet. Vi tror ofte, at vi skal holde fast — i
              relationer, i identiteter, i forestillinger om, hvem vi er. Men
              der findes øjeblikke, hvor det, der engang gav os næring, ikke
              længere gør det.
            </p>
            <p className="font-serif italic text-cm-ink text-lg sm:text-xl leading-relaxed pt-4">
              At give slip er ikke et nederlag. Det er en form for{" "}
              <span className="text-cm-rose">modenhed</span>.
            </p>
          </div>
        </div>

        <div className="lg:col-span-4 reveal order-1 lg:order-2 lg:pt-8">
          <div className="relative w-full max-w-[280px] mx-auto">
            <div className="relative rounded-sm overflow-hidden border border-cm-line bg-cm-surface shadow-[0_30px_60px_-30px_rgba(196,139,139,0.4)]">
              <img
                src="/brand/cm-fjende.jpg"
                alt="En fjende kan blive til en ven"
                loading="lazy"
                data-testid="manifesto-image"
                className="w-full h-auto block transition-transform duration-[1600ms] hover:scale-[1.02]"
              />
            </div>
            <div
              aria-hidden
              className="absolute -top-5 -left-5 w-20 h-20 rounded-full border border-cm-rose/30 pointer-events-none hidden sm:block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
